import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, ViewChild, EventEmitter, Output, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { MapsService } from '../../services/maps.service';
import { MapModel, Route, StoppingPlace, MapPois, MapPoiMarker } from '../../models/map.model';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil, take, skip } from 'rxjs/operators';
import { AgmMap } from '@agm/core';
import { AppSettings } from '../../settings/app.settings';

import { environment } from '../../../environments/environment';
import { GeoJson, FeatureCollection } from '../../models/mapbox.model';

declare let mapboxgl: any;

@Component({
  selector: 'css-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy, OnChanges {

  @Input('product-id') productId: number;
  @Input('device') device: string;
  // @Output() firstInteractionEvent = new EventEmitter<boolean>();
  @Output('on-menu-displayed') menuDisplayed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('agmMap') agMap: AgmMap;

  public isNode: boolean;

  public map: MapModel;
  public mapPois: MapPois[]; //  aux map icon list
  /** Route that will be drawn in the map */
  public selectedRoute: Route;
  /** Stop clicked by the user */
  public selectedStop: StoppingPlace;
  public loaded: boolean = false;
  public mapZoomControl: number;
  public limitMapZoom: number;
  /** Latitude where the map is centered */
  public centerLat: number;
  /** Longitude where the map is centered */
  public centerLng: number;
  /** Custom icon */
  public icon: any;
  /** Boolean to control lateral menu */
  public showSidebar: boolean;
  /** Repeat routes */
  public listStops: StoppingPlace[] = [];
  /** Index */
  public startIndex: number;
  public endIndex: number;

  /** Indicates if the user has interacted with the map */
  // public firstInteraction = false;

  /** Animations controls */
  public openSideMenuAnimation: boolean = false;
  public closeSideMenuAnimation: boolean = false;
  public zIndex: number = 0;

  public mapStyleConfig: any = [];
  private unsubscribe$ = new Subject<void>();
  public mapbox: any;
  public style: string;
  public currentLat: number;
  public currentLng: number;
  public currentPosition: GeoJson;
  public currentMapboxPopup: any;
  private _getCurrentPositionInterval: any;
  private _getCurrentPositionOptions: any;
  // interval to repaint the current position (milliseconds)
  public _currentPositionInterval: number;

  constructor(
    private mapsService: MapsService,
    private _r2: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.isNode = true;
    this.style = 'mapbox://styles/mapbox/streets-v11';
    this.currentLat = 0;
    this.currentLng = 0;
    this._getCurrentPositionInterval = null;
    this._getCurrentPositionOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    };
    this._currentPositionInterval = 10000;
  }

  ngOnInit() {
    this.isNode = isPlatformServer(this.platformId);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.startIndex = -1;
    this.endIndex = 3;
    if (this.device === 'mobile') {
      this.showSidebar = false;
    } else {
      this.showSidebar = this.isfixedSideMenu(true);
    }
    for (const propName in changes) {
      if (propName === 'productId') {
        if (changes) {
          this.updateData();
        }
      }
    }
    /** Style config for a light map */
    this.mapStyleConfig =
      [
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            { saturation: -100 },
            { visibility: 'simplified' }
          ]
        }, {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            { visibility: 'simplified' }
          ]
        }, {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            { visibility: 'off' }
          ]
        }, {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            { visibility: 'off' }
          ]
        }, {
          featureType: 'landscape',
          elementType: 'labels',
          stylers: [
            { visibility: 'off' }
          ]
        }
      ];
  }

  /**
   * Receive and update map data, mark first route as selected and center the mapa
   */
  updateData() {
    this.mapsService.getMapByProduct(this.productId).pipe(takeUntil(this.unsubscribe$))
      .subscribe(data => {
        this.listStops = this.getRepeatStops(data.listStops, data.repeatStops);
        this.addColorStops(data, (d) => this.map = d);
        this.map = data;
        this.map.routes[0].showStopList = true;
        this.map.routes[0].zIndex = 10;
        this.mapZoomControl = this.map.zoom;
        this.limitMapZoom = this.map.zoom - 2;
        this.loaded = true;
        this.centerLat = this.map.lat;
        this.centerLng = this.map.lng;
        this.mapPois = this.map.pois.map(poi => {
          poi.icon = <MapPoiMarker>{};
          poi.icon.scaledSize = {
            height: 100,
            width: 100
          };
          poi.icon.url = `${AppSettings.POI_IMAGES}${poi.image}`;
          return poi;
        });
        if (!this.isNode) {
          /////////////////////////////////////////////// map with mapbox
         /*  mapboxgl.accessToken = environment.mapbox.accessToken;
          this.mapbox = new mapboxgl.Map({
            container: 'mapbox', // container id
            style: this.style,
            center: [this.currentLng, this.currentLat],
            zoom: 14 // starting zoom
          });
          this.mapbox.scrollZoom.disable();
          this.mapbox.addControl(new mapboxgl.NavigationControl({
            zoomIn: true,
            zoomOut: true
          }));
          this.mapbox.flyTo({
            center: [this.centerLng, this.centerLat]
          });
          this._buildMap(); */
          /////////////////////////////////////////////// end of map with mapbox
        }
      });
  }

  /**
  * function to buils map of mapbox
  *
  */
  private _buildMap(): void {
    const routeStopsIds: Array<string> = [];
    this.mapbox.on('load', (event) => {
      ////////////////////////////////////////////////////////////////////////////  route's points (line)
      this.map.routes.forEach((route) => {
        this._paintRoute(route);
      });
      ///////////////////////////////////////////////////////////////////////////// route's stops
      this.map.routes.forEach((route) => {
        this._paintRouteStops(route);
        routeStopsIds.push('routeStopsId_' + route.id);
      });
      ///////////////////////////////////////////////////////////////////////////// poi's
      this.mapPois.forEach((poi) => {
        const imageURL = poi.icon.url;
        const poiDiv = this._r2.createElement('div') as HTMLElement;
        const img = this._r2.createElement('img') as HTMLElement;
        this._r2.setAttribute(img, 'src', imageURL);
        this._r2.addClass(poiDiv, 'poi-marker');
        this._r2.appendChild(poiDiv, img);
        new mapboxgl.Marker(poiDiv)
          .setLngLat([poi.lng, poi.lat])
          .addTo(this.mapbox);
      });
      ///////////////////////////////////////////////////////////////////////  current Position
      const MAPBOX = this.mapbox;
      const size: number = 120;
      const currentPositionDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext('2d');
        },
        render: function () {
          const duration: number = 1000;
          const t = (performance.now() % duration) / duration;
          const radius = size / 2 * 0.3; // 18
          /* const outerRadius = size / 2 * 0.1 * t + radius; */
          const context = this.context;
          // draw outer circle
          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
          context.fillStyle = 'rgba(255, 200, 200,' + (1 - t) + ')';
          context.fill();
          // draw inner circle
          context.beginPath();
          context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
          context.fillStyle = 'rgba(255, 100, 100, 1)';
          context.strokeStyle = 'white';
          context.lineWidth = 2 + 4 * (1 - t);
          context.fill();
          context.stroke();
          // update this image's data with data from the canvas
          this.data = context.getImageData(0, 0, this.width, this.height).data;
          // keep the map repainting
          MAPBOX.triggerRepaint();
          // return `true` to let the map know that the image was updated
          return true;
        }
      };
      this.mapbox.addImage('currentPosition-dot', currentPositionDot, { pixelRatio: 2 });
      this._initializeMapPosition();
      ///////////////////////////////////////////////////////////////////////  bind events of mapbox
      this._bindMapboxEvents(routeStopsIds);
    });
  }

  /**
  * function to initialize the map of mapbox
  */
  private _initializeMapPosition(): void {
    if (window && window.navigator && window.navigator.geolocation) {
      this._getCurrentPosition(false);
      // Code to get current position of user every 10 seconds
      if (this._getCurrentPositionInterval) {
        clearInterval(this._getCurrentPositionInterval);
      }
      this._getCurrentPositionInterval = setInterval(() => {
        this._getCurrentPosition(true);
      }, this._currentPositionInterval);
    }
  }

  /**
   * funtion to get current position of user
  */
  private _getCurrentPosition(flag: boolean): void {
    window.navigator.geolocation.getCurrentPosition((position: Position) => {
      this.currentLat = position.coords.latitude;
      this.currentLng = position.coords.longitude;
      if (flag) {
        this._repaintCurrentPosition();
      } else {
        this._paintCurrentPosition();
      }
      // if we want to focus on current position
      /* this.mapbox.flyTo({
        center: [this.currentLng, this.currentLat] // lng, lat
      }); */
    }, error => {
      switch (error.code) {
        case 3:
          // ...deal with timeout
          break;
        case 2:
          // ...device can't get data
          break;
        case 1:
        // ...user said NO
      }
    }, this._getCurrentPositionOptions);
  }

  /**
  * function to re-paint the current position
  * @param
  */
  private _repaintCurrentPosition(): void {
    // removing data
    // removing data
    const _target: string = 'currentPosition';
    this.mapbox.removeLayer(_target);
    this.mapbox.removeSource(_target);
    // repainting data
    this._paintCurrentPosition();
  }

  /**
  * function to paint the current position
  * @param
  */
  private _paintCurrentPosition(): void {
    this.mapbox.addLayer({
      id: 'currentPosition',
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [{
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [this.currentLng, this.currentLat]
            }
          }]
        }
      },
      layout: {
        'icon-image': 'currentPosition-dot'
      }
    });
  }

  /**
  * function to re-paint the route of mapbox
  * @param route
  */
  private _repaintRoute(route): void {
    // removing data
    const _target: string = 'routePoints_' + route.id;
    this.mapbox.removeLayer(_target);
    this.mapbox.removeSource(_target);
    // repainting data
    this._paintRoute(route);
  }

  /**
  * function to paint the route of mapbox
  * @param route
  */
  private _paintRoute(route): void {
    const _visibility = route.isSelected ? 'visible' : 'none';
    const _routeColor = route.color;
    const _routeId = route.id;
    const _routePoints = route.routePoints.map(item => {
      return [item.lng, item.lat];
    });
    this.mapbox.addLayer({
      id: 'routePoints_' + _routeId,
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: _routePoints
          }
        }
      },
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
        'visibility': _visibility
      },
      paint: {
        'line-color': _routeColor,
        'line-width': 4
      }
    });
  }

  /**
  * function to re-paint the route's stops of mapbox
  * @param route
  */
  private _repaintRouteStops(route): void {
    // removing data
    let _target: string = 'routeStopsBg_' + route.id;
    this.mapbox.removeLayer(_target);
    this.mapbox.removeSource(_target);
    _target = 'routeStopsId_' + route.id;
    this.mapbox.removeLayer(_target);
    this.mapbox.removeSource(_target);
    // repainting data
    this._paintRouteStops(route);
  }

  /**
  * function to paint the route's stops of mapbox
  * @param route
  */
  private _paintRouteStops(route): void {
    const _visibility = route.isSelected ? 'visible' : 'none';
    const _routeColor = route.color;
    const _routeId = route.id;
    const _routeStops = route.stoppingPlaces.map((item, i) => {
      const _routeStop: GeoJson = new GeoJson([item.lng, item.lat]);
      _routeStop.properties = {
        id: i + 1,
        description: item.name,
        colorAux: item.colours[1] ? item.colours[1] : _routeColor
      };
      return _routeStop;
    });
    const data: FeatureCollection = new FeatureCollection(_routeStops);
    this.mapbox.addLayer({
      id: 'routeStopsBg_' + _routeId,
      type: 'circle',
      source: {
        type: 'geojson',
        data: data
      },
      layout: {
        'visibility': _visibility
      },
      paint: {
        'circle-radius': 15,
        'circle-color': _routeColor,
        'circle-stroke-width': 3,
        'circle-stroke-color': [
          'match',
          ['get', 'colorAux'],
          _routeColor, _routeColor,
          ['get', 'colorAux']
        ]
      }
    });
    this.mapbox.addLayer({
      id: 'routeStopsId_' + _routeId,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: data
      },
      layout: {
        'text-field': '{id}',
        'text-font': ['Open Sans Bold'],
        'text-size': 17,
        'text-justify': 'center',
        'visibility': _visibility
      },
      paint: {
        'text-color': '#FFF'
      }
    });
  }

  /**
  * function to bind mapbox's events
  * @param target
  */
  private _bindMapboxEvents(target: Array<string>): void {
    // When a click event occurs on a feature in the routeStops_id layer, open a popup at the
    // location of the feature, with description HTML from its properties.
    target.forEach((item) => {
      this.mapbox.on('click', item, (event) => {
        const coordinates = [event.lngLat.lng, event.lngLat.lat];
        const description = event.features[0].properties.description;
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
        }
        this.currentMapboxPopup = new mapboxgl.Popup({ offset: 25 })
          .setLngLat(coordinates)
          .setHTML(`<p class='body'>${description}</p>`)
          .addTo(this.mapbox);
      });
      // Change the cursor to a pointer when the mouse is over the routeStops_id layer.
      this.mapbox.on('mouseenter', item, (event) => {
        this.mapbox.getCanvas().style.cursor = 'pointer';
      });
      // Change it back to a pointer when it leaves.
      this.mapbox.on('mouseleave', item, (event) => {
        this.mapbox.getCanvas().style.cursor = '';
      });
    });
    this.mapbox.on('touchstart', (event) => {
      this.mapbox.dragPan.disable();
    });
  }

  /**
   * maybe change to a service
   * @param stop
   */
  createSVG(stop) {
    const originalSvgElem = document.getElementById('svg');
    const svgElem = <HTMLElement>originalSvgElem.cloneNode(true);
    let current = 0.5;
    const step = 100 / (stop.colours.length);
    stop.colours.forEach(color => {
      const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle.setAttributeNS(null, 'r', '25%');
      circle.setAttributeNS(null, 'cx', '50%');
      circle.setAttributeNS(null, 'cy', '50%');
      circle.style.strokeDasharray = `${101 - current} 100`;
      circle.style.stroke = color;
      circle.style.fill = 'none';
      circle.style.strokeWidth = '32';
      svgElem.appendChild(circle);
      svgElem['style'].transform = 'rotate(-90deg)';
      current = current + step;
    });
    if (svgElem.outerHTML) {
      stop.icon = 'data:image/svg+xml;base64,' + btoa(svgElem.outerHTML.toString());
    }
  }

  /**
   * Get the different repeated routes
   * @param listStops list of all stops
   * @param name list of stop names repeated
   */
  getRepeatStops(listStops, name): StoppingPlace[] {
    const stops: StoppingPlace[] = [];
    listStops.map(stop => {
      if (name.indexOf(stop.id) !== -1) {
        stops.push(stop);
      }
    });
    return stops;
  }

  /**
   * Loop into stoppingPlaces stops, if stop is repeat try to add color if doest exist yet in array colours
   * @param data response map data
   * @param cb callback
   */
  addColorStops(data, cb) {
    data.routes.map(route => {
      route.zIndex = this.zIndex;
      route.isSelected = true;
      route.stoppingPlaces.map(stop => {
        this.listStops.map(s => {
          if (stop.id === s.id && stop.colours.indexOf(s.colours[0]) === -1) {
            stop.colours.push(s.colours[0]);
          }
        });
        this.createSVG(stop);
      });
    });
    data.routes.sort((a, b) => a.order - b.order);
    return cb(data);
  }

  /**
   * When the component is destroyed, it is unsubscribed.
   */
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    // cleaning interval for getting currentPosition
    if (this._getCurrentPositionInterval) {
      clearInterval(this._getCurrentPositionInterval);
    }
  }

  /**
   * Map load complete
   */
  mapReady() {
    //  We only need the first interaction of the user.
    // this.agMap.boundsChange.pipe(skip(1)).pipe(take(1)).subscribe(() => this.checkFirstInteraction());
  }

  /**
   * Picks up the click on map to remove stop info window and hide lower menu for mobile
   */
  mapClick() {
    this.selectedStop = null;
    if (this.device === 'mobile') {
      this.showSidebar = false;
    }
    this.hideStopsDetails();
  }

  /**
   * Hide all routes
   */
  private hideRoutesDetails() {
    this.map.routes.map(routes => {
      routes.showStopList = false;
    });
  }

  /**
   * Hide all stops
   */
  private hideStopsDetails() {
    this.map.routes.map(routes => {
      if (routes.isSelected) {
        routes.stoppingPlaces.map(stop => {
          stop.isSelected = false;
        });
      }
    });
  }

  /**
   * Click on marker to show stop info window on map
   * @param stop the mark return will return the selected stop
   * @param route pass the selected route
   * @param command action to determine if it comes from the map or from the lower menu
   */
  onMarkerClick(stop: StoppingPlace, route: Route = this.selectedRoute, command?: string) {
    try {
      this.hideStopsDetails();
      this.selectedStop = stop;
      stop.isSelected = true;

      if (this.selectedStop) {
        this.centerLat = this.selectedStop.lat;
        this.centerLng = this.selectedStop.lng;
        this.selectedRoute = route;
      }
    } catch (ex) { }
  }

  /**
   * Event zoom from map
   * @param event zoom event
   */
  zoomChange(event) {
     // TODO PROVISIONAL
     let dimension;
     if (event > 16) {
       dimension = 160;
     } else if (event === 16) {
       dimension = 130;
     } else if (event === 15) {
       dimension = 100;
     } else {
       dimension = 80;
     }
     this.mapZoomControl = event;
     this.mapPois = [];
     setTimeout(() => {
       this.mapPois = this.map.pois.map(poi => {
         poi.icon = <MapPoiMarker>{};
         poi.icon.scaledSize = {
           height: dimension,
           width: dimension
         };
         poi.icon.url = `${AppSettings.POI_IMAGES}${poi.image}`;
         return poi;
       });
     }, 200);
   }

  /**
   * Close stop info window
   */
  onInfoWindowClickOnClose(stop) {
    this.selectedStop = null;
  }

  /**
   * Click on the list of stops in the side menu
   * @param route stop route
   * @param stopNumber number of the stop selected
   */
  onRouteStopClick(route: Route, stop: StoppingPlace) {
    this.hideStopsDetails();
    if (route.isSelected) {
      const selRoute = this.map.routes.find(r => r.id === route.id);
      this.selectedRoute = selRoute;
      stop.isSelected = true;
      if (selRoute) {
        const selStop = selRoute.stoppingPlaces.find(s => s.id === stop.id);
        if (selStop) {
          this.showSidebar = this.isfixedSideMenu(false);
          this.selectedStop = selStop;
          this.centerLat = selStop.lat;
          this.centerLng = selStop.lng;
          //////////////////////////////////////////////// popups with mapbox
          /* const coordinates = [selStop.lng, selStop.lat];
          const description = selStop.name;
          while (Math.abs(selStop.lng - coordinates[0]) > 180) {
            coordinates[0] += selStop.lng > coordinates[0] ? 360 : -360;
          }
          if (this.currentMapboxPopup) {
            this.currentMapboxPopup.remove();
          }
          this.currentMapboxPopup = new mapboxgl.Popup({ offset: 25 })
            .setLngLat(coordinates)
            .setHTML(`<p class='body'>${description}</p>`)
            .addTo(this.mapbox);
          // center the map
          this.mapbox.flyTo({
            center: [coordinates[0], coordinates[1]]
          }); */
          //////////////////////////////////////////// end popups with mapbox

        }
      }
    }
  }

  /**
   * Click on the side menu route, hides lower menu & stop info window if route is unchecked
   * @param route route selected
   */
  onRouteClick(route: Route) {
    // this.checkFirstInteraction();
    if (route) {
      route.isSelected = !route.isSelected;
      route.zIndex = this.zIndex;
      ////////////////////////////////////// for mapbox
     /*  if (this.currentMapboxPopup) {
        this.currentMapboxPopup.remove();
      }
      this._repaintRoute(route);
      this._repaintRouteStops(route); */
      ////////////////////////////////// end for mapbox
    }
  }

  /**
   * Show route stops list
   * @param route route selected
   */
  showStopList(route: Route) {
    // this.checkFirstInteraction();
    if (route) {
      ////////////////////////////////////// for mapbox
      /* this._repaintRouteStops(route); */
      ////////////////////////////////////// end for mapbox
      this.zIndex++;
      this.hideRoutesDetails();
      if (route.isSelected) {
        route.zIndex = this.zIndex;
      }
      route.showStopList = !route.showStopList;
    }
  }

  /**
   * Desktop always has side menu position relative, pass correct condition state for mobile
   */
  isfixedSideMenu(condition): boolean {
    return this.device === 'desktop' ? true : condition;
  }

  /**
   * Open side menu
   */
  openSideMenu() {
    this.menuDisplayed.emit(true);
    // this.checkFirstInteraction();
    this.showSidebar = this.isfixedSideMenu(true);
    this.openSideMenuAnimation = true;
    setTimeout(() => {
      this.openSideMenuAnimation = false;
    }, 300);
  }

  /**
   * Close side menu
   */
  closeSideMenu() {
    this.closeSideMenuAnimation = true;
    setTimeout(() => {
      this.showSidebar = this.isfixedSideMenu(false);
      this.closeSideMenuAnimation = false;
    }, 300);
  }

  /**
   * Previous route icon
   */
  previousItem() {
    if (this.startIndex !== -1) {
      this.startIndex--;
      this.endIndex--;
    }
  }

  /**
   * Next route icon
   */
  nextItem() {
    if (this.endIndex !== this.map.routes.length) {
      this.startIndex++;
      this.endIndex++;
    }
  }

  /** Function that fires that controls and fires the first interaction event. It is for analytics pourposes */
  /* private checkFirstInteraction() {
    if (this.firstInteraction === false) {
      this.firstInteraction = true;
      this.firstInteractionEvent.emit(true);
    }
  } */

}
